import { render } from "./shojo.vue?vue&type=template&id=52259031"
import script from "./shojo.vue?vue&type=script&lang=js"
export * from "./shojo.vue?vue&type=script&lang=js"

import "./shojo.vue?vue&type=style&index=0&id=52259031&lang=css"

import exportComponent from "/Users/nekomini/.gitlab-runner/builds/pUzgx6Vs/0/neko_client_projects/shojo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__